import {Link} from '@flixbus/honeycomb-react';
import * as yup from 'yup';
import {CountryPanelFormData} from './CountryPanel.types';
import {ValueDimension} from '../index.constants';

export enum ErrorType {
  Name = 'Name',
  CountryCodes = 'CountryCodes'
}

export const errorMessages: {
  [errorType in ErrorType]: React.ReactNode;
} = {
  [ErrorType.Name]: 'Country name is required',
  [ErrorType.CountryCodes]: (
    <>
      Please enter a valid country code and subdivision following the{' '}
      <Link target="_blank" href="https://www.iso.org/obp/ui/#search">
        ISO 3166
      </Link>{' '}
      format (e.g., US for United States, US-TX for Texas)
    </>
  )
};

export const countryPanelSchema: yup.ObjectSchema<CountryPanelFormData> =
  yup.object({
    id: yup.string().optional(),
    name: yup.string().required(ErrorType.Name),
    businessRegion: yup.string().optional(),
    currency: yup.string().required(),
    repairCostDimension: yup.mixed<ValueDimension>().required(),
    maintenanceCostDimension: yup.mixed<ValueDimension>().required(),
    countryCodes: yup
      .array()
      .of(
        yup
          .string()
          .required()
          .matches(/^[A-Z]{2}(-[A-Z0-9]{1,3})?$/, ErrorType.CountryCodes)
      )
      .default([])
      .defined()
  });
